import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import InterestRow from './InterestRow';
import { Table, TableBody, TableHeader, TableRow, TableHeaderColumn } from 'material-ui/Table';
import { grey50 } from 'material-ui/styles/colors';

const EmptyInterests = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 200px);
`;

const tableHeaderStyle = {
    backgroundColor: grey50
};

export const columnNameStyle = {
    width: 200
};

export const columnIconMenuCellStyle = {
    width: 54,
    paddingRight: 6,
    paddingLeft: 0
};

export const columnIsDefaultInterestStyle = {
    width: 60,
    paddingRight: 0,
    paddingLeft: 0,
    textAlign: 'center'
};

const InterestsTable = ({ interestsList = [] }) => {
    if (!interestsList.length) {
        return (
            <EmptyInterests>
                <h2>There are no interests currently. Create the first one.</h2>
            </EmptyInterests>
        );
    }

    return (
        <Table selectable={false} hoverable={false}>
            <TableHeader
                displaySelectAll={false}
                adjustForCheckbox={false}
                enableSelectAll={false}
                style={tableHeaderStyle}
            >
                <TableRow>
                    <TableHeaderColumn style={columnNameStyle}>Name</TableHeaderColumn>
                    <TableHeaderColumn>Interests</TableHeaderColumn>
                    <TableHeaderColumn style={columnIsDefaultInterestStyle}>Default</TableHeaderColumn>
                    <TableHeaderColumn style={columnIconMenuCellStyle} />
                </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false} showRowHover={false} deselectOnClickaway={false}>
                {interestsList.map(interestId => <InterestRow key={interestId} id={interestId} />)}
            </TableBody>
        </Table>
    );
};

InterestsTable.propTypes = {
    interestsList: PropTypes.array
};

export default connect(({ requery }) => ({
    interestsList: requery.list && requery.list.userInterests
}))(InterestsTable);



/** WEBPACK FOOTER **
 ** ../src/dash/front/interests-page/components/InterestsTable/index.js
 **/